function n(e) {
  if (typeof document > "u")
    return e;
  const t = document.createElement("textarea");
  return t.innerHTML = e, t.value;
}
function r(e) {
  return !e || e.trim() === "" ? "" : new DOMParser().parseFromString(e, "text/html").documentElement.textContent?.trim() || "";
}
export {
  r as htmlToTextContent,
  n as unescape
};
